import { render, staticRenderFns } from "./DashboardNavigation.vue?vue&type=template&id=508e2b54&scoped=true"
import script from "./DashboardNavigation.vue?vue&type=script&lang=js"
export * from "./DashboardNavigation.vue?vue&type=script&lang=js"
import style0 from "./DashboardNavigation.vue?vue&type=style&index=0&id=508e2b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e2b54",
  null
  
)

export default component.exports